import { DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-SectionHeader',
	toggle: 'c-SectionHeader--toggle',
	chevron: 'c-SectionHeader__chevron',
	title: 'c-SectionHeader__title',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(1),
		width: '100%',
		padding: `${DefaultTheme.space(1)} 0`,
		'font-family': 'inherit',
		'font-size': 'inherit',
		'font-weight': 'bold',
		color: DefaultTheme.font.color.supporting,
		background: 'none',
		border: 'none',
		'text-align': 'left',
		'user-select': 'none',
	},
	[CSS.toggle]: { cursor: 'pointer' },
	[CSS.chevron]: { 'font-size': '18px' },
	// The hint hugs the title (rather than right-aligning) so it can't read as a column header.
	[CSS.title]: { flex: '0 1 auto' },
};
